export default __webpack_public_path__ + "4d22f1e5a1ab21e67df79e7e99af62a5.png";